import React from 'react';

const MembershipBenefits = () => {
  const benefits = [
    'Access to exclusive networking events',
    'Priority registration for summits',
    'Investment matchmaking services',
    'Market intelligence reports',
    'Visibility in members showcase',
    'Direct access to government officials'
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Membership Benefits</h1>
        <p>Exclusive advantages for forum members</p>
      </section>
      <section className="page-content">
        <div className="container">
          <ul className="benefits-list">
            {benefits.map((benefit, index) => (
              <li key={index}>✓ {benefit}</li>
            ))}
          </ul>
          <button className="btn-gold" style={{marginTop: '30px'}} onClick={() => window.location.href='/become-member'}>Become a Member</button>
        </div>
      </section>
    </div>
  );
};

export default MembershipBenefits;